import { baseQueryClient } from '@aibees/shared/http';
import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import { debounce } from 'lodash-es';
import { useRef } from 'react';
import { useBrowseNotificationsApi } from '../api/use-browse-notifications-api';
import { useBrowseNotificationsCountApi } from '../api/use-browse-notifications-count-api';
import { NotificationCountSocketMessage } from '../types';

export function useSocketNotification() {
  const channel = useGetSocketChannel(SocketMessageType.NOTIFICATION_COUNT);

  const debouncedInvalidate = useRef(
    debounce(
      () => baseQueryClient.invalidateQueries([useBrowseNotificationsApi.name]),
      500
    )
  ).current;

  const debouncedInvalidateCount = useRef(
    debounce(
      () =>
        baseQueryClient.invalidateQueries([
          useBrowseNotificationsCountApi.name,
        ]),
      500
    )
  ).current;

  useSocketEvent(channel, (data: NotificationCountSocketMessage) => {
    if (data.type === SocketMessageType.NOTIFICATION_COUNT) {
      debouncedInvalidate();
      debouncedInvalidateCount();
    }
  });
}
